import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=e0682276&"
import script from "./Properties.vue?vue&type=script&lang=ts&"
export * from "./Properties.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports